
import validator from 'validator';

const ValidateEditService = (data) => {
    let errors = {};

    const { information_description } = data;

    if (!information_description) {
        errors.information_description = '설명은 필수 입력 사항입니다.';
    }
    else if (validator.isEmpty(information_description)) {
        errors.information_description = '설명은 필수 입력 사항입니다.';
    }
    // else if (information_description === '<br>' || information_description === '<div>' || information_description === '<p>') {
    //     errors.information_description = '설명은 필수 입력 사항입니다.';
    // }
    return {
        isInvalid: Object.keys(errors).length > 0,
        error: errors,
    };
};

export default ValidateEditService;
